import { COLORS, H2Flow, TextBudgetFlow } from '@monthio/react-components'
import styled, { css } from 'styled-components'

export const BudgetSectionContainer = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	background-color: ${COLORS.GREY_SCALE.WHITE};
	color: ${COLORS.TEXT_COLORS.DEFAULT};
	justify-content: space-around;
	margin-bottom: ${(props) => props.theme.spacing(4)}px;
	box-shadow: 0 0 14px rgba(53, 64, 82, 0.05);
	border: none;
	border-radius: ${(props) => props.theme.body.borderRadius}px;
	box-sizing: border-box;
	padding-right: 14px;
	padding-left: 16px;

	${(props) => props.theme.breakpoints.up('sm')} {
		padding-right: 22px;
		padding-left: 24px;
	}

	${(props) => props.theme.breakpoints.up('lg')} {
		padding-right: 30px;
		padding-left: 24px;
	}
`

export const BudgetSectionHeader = styled.div`
	display: flex;
	flex-direction: row;
	background-color: transparent;
	justify-content: space-between;
	cursor: ${(props) => (props.onClick != null ? 'pointer' : 'initial')};
	min-height: 49px;
	box-sizing: border-box;
`

const textContainerStyle = css`
	align-self: center;
	max-width: calc(100vw - 200px);
	overflow-wrap: break-word;

	${(props) => props.theme.breakpoints.up('sm')} {
		max-width: calc(100vw - 250px);
	}

	${(props) => props.theme.breakpoints.up('lg')} {
		max-width: initial;
	}
`

export const BudgetSectionTitle = styled(H2Flow)`
	${textContainerStyle}
`

export const BudgetSectionAmount = styled(H2Flow)<{ $positive?: boolean }>`
	align-self: center;
	margin-left: 5px;
	color: ${(props) =>
		props.$positive ? COLORS.OTHER_COLORS.DARK_MONEY_GREEN : 'initial'};
`

export const InitialAmountValue = styled(TextBudgetFlow)`
	color: ${COLORS.TEXT_COLORS.INACTIVE};
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-right: 5px;
`

export const AmountAndExpandIconContainer = styled.div`
	display: flex;
	flex-direction: row;
`

export const DataPointSectionDiv = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	margin-top: 12px;
	color: ${COLORS.TEXT_COLORS.INACTIVE};
	cursor: pointer;
	&:first-child {
		margin-top: 16px;
	}
	&:last-child {
		margin-bottom: 21px;
	}
`

export const DataPointName = styled(TextBudgetFlow)`
	${textContainerStyle}
`
